import styled from 'styled-components'
import SMBContainer from '@components/Container'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'

export const Main = styled.footer`
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5fa;
`

export const Box = styled.section`
  @media (min-width: ${getBreakpoint('xl')}px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const Container = styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    max-width: 479px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Rights = styled.section`
  padding-top: 40px;
  padding-bottom: 24px;
  background-color: #231b22;

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`

export const ReCaptchaRights = styled.p`
  font-style: normal;
  font-family: Rubik;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #9898a6;
  margin: 0;

  a {
    font-weight: 600;
    text-decoration: none;
    color: #d8385e;
  }
`

export const GympassRights = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  color: #9898a6;
  margin: 40px 0 0;
  font-family: Rubik;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 0;
  }
`

export const Subtitle = styled(Box)`
  color: #ff4438;
  font-weight: bold;
  font-style: normal,
  line-height: 14px;
  font-family: Rubik;
`

export const FooterImage = styled(Image)`
  display: none;

  @media (min-width: ${getBreakpoint('md')}px) {
    display: block;
    float: right;
    margin-top: -173px;
    margin-right: -80px;
  }
`
